import React from 'react';
import moment from 'moment';
import FontAwesomeIcon from '../Icon';
import Button from '../Button';
import TextEditor from '../Editor/Editor';
import { convertToDisplayText } from 'src/helpers/validationHelper';
import 'src/components/Notes/notes-repeater.scss';

interface MaintenanceGuideRepeaterProps {
  from: any;
  onEdit: (maintenanceguide: any) => void;
  onDelete: (maintenanceguide: any) => void;
  maintenanceguides: any[];
  onlyView?: boolean;
}

const formatRepeatSuffix = (guide: any, withLeadingComma: boolean): string => {
  if (!guide.repeatType) {
    return '';
  }

  const repeatLabel: string =
    guide.repeatType === 'Custom'
      ? `${guide.repeatEvery} ${convertToDisplayText(
          guide.repeatTypeEvery,
          guide.repeatEvery
        )}`
      : convertToDisplayText(guide.repeatType, null);

  const prefix: string = withLeadingComma ? ', repeat every ' : 'Repeat every ';

  return `${prefix}${repeatLabel}`;
};

const renderAppointmentText = (from: any, guide: any): React.ReactNode => {
  const isCatalog: boolean = from === 'Catalog';
  const usesWarrantyStart: boolean = !!guide.IsSuiteWarrantyStartDate;

  if (isCatalog && usesWarrantyStart) {
    return <>{formatRepeatSuffix(guide, false)}</>;
  }

  const dateSource: Date = usesWarrantyStart
    ? guide.reminderDate
    : guide.appointment?.date;
  const timeSource: Date = usesWarrantyStart
    ? guide.time
    : guide.appointment?.time;

  const formattedDate: string = moment(dateSource).format('dddd MM/DD/YYYY');
  const formattedTime: string = moment(timeSource).format('hh:mm A');

  return (
    <>
      {formattedDate} {formattedTime}
      {formatRepeatSuffix(guide, true)}
    </>
  );
};

const MaintenanceGuideRepeater = ({
  from,
  onEdit,
  onDelete,
  maintenanceguides,
  onlyView,
}: MaintenanceGuideRepeaterProps) => (
  <div className="note-card-scroll-wrapper">
    {maintenanceguides.map((guide: any, index: number) => {
      const showActions: boolean = onlyView !== true;
      const hasAppointment: boolean = !!guide.appointment;

      return (
        <div key={index} className="note-card">
          <div className="note-card-content">
            <div className="note-card-title">
              {hasAppointment && <>[Reminder] </>}
              {guide.title}
            </div>
            {hasAppointment && (
              <div className="note-card-appointment">
                <FontAwesomeIcon
                  glyph="calendar"
                  weight="solid"
                  size="medium"
                />
                {renderAppointmentText(from, guide)}
              </div>
            )}
            <div className="note-card-body">
              <div className="note-card-editor-clean">
                <TextEditor
                  editorState={guide.body}
                  readOnly={true}
                  onEditorStateChange={null}
                />
              </div>
            </div>
            {showActions && (
              <div className="note-card-footer">
                <div />
                <div className="note-card-actions">
                  <Button
                    color="semantic"
                    onClick={() => onEdit(guide)}
                    label={<FontAwesomeIcon glyph="pencil" weight="light" />}
                  />
                  <Button
                    color="semantic"
                    onClick={() => onDelete(guide)}
                    label={<FontAwesomeIcon glyph="trash" weight="light" />}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      );
    })}
  </div>
);

export default MaintenanceGuideRepeater;
